import { css } from '@emotion/react';

export const mainContainer = (isRoot) => css`
    display: flex;
    align-items: center;
    height: 50px;
    background-color: ${isRoot ? '#fdfdfd' : '#002755'};
`;

export const toolbar = (isRoot) => css`
    display: flex;
    width: 1400px;
    min-height: 100% !important;
    background-color: ${isRoot ? '#fdfdfd' : '#002755'};
    justify-content: space-between;
    align-items: center;
`;

export const logo = css`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-start;
`;

export const logoClickArea = css`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding: 0;
    margin: 0;
    width: auto;
    height: auto;
`;

export const logoImg = css`
    width: 135px;
`;

export const subText = (isRoot) => css`
    padding-left: 10px;
    color: ${isRoot ? '#777777' : '#fdfdfd'};
    font-size: 17px;
`;

export const logoButton = (isRoot) => css`
    display: inline-flex;
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    transform: translate(0, 10%);
    flex: 1;

    img {
        width: 135px;
    }

    span {
        padding-left: 10px;
        color: ${isRoot ? '#777777' : '#fdfdfd'};
        font-size: 17px;
    }
`;

export const navigationContainer = css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    gap: 10px;
`;

export const navigationButton = (isRoot) => css`
    min-width: 155px;
    transition: all 0.3s ease;
    color: ${!isRoot ? '#fdfdfd' : '#002755'};
    padding: 0 5px;

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const dropdownContainer = css`
    position: relative;
    display: inline-block;
`;

export const dropdownMenu = (isRoot) => css`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: ${isRoot ? '#fdfdfd' : '#002755'};
    border: 1px solid ${isRoot ? '#e0e0e0' : '#1a4a8a'};
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    min-width: 140px;
    margin-top: 2px;
`;

export const dropdownItem = (isRoot) => css`
    padding: 8px 12px;
    color: ${!isRoot ? '#fdfdfd' : '#002755'};
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;

    &:hover {
        background-color: ${isRoot ? '#f5f5f5' : '#1a4a8a'};
    }

    &:first-of-type {
        border-radius: 4px 4px 0 0;
    }

    &:last-of-type {
        border-radius: 0 0 4px 4px;
    }
`;

export const mailButton = (isRoot) => css`
    min-width: 40px;
    min-height: 40px;
    transition: all 0.3s ease;
    color: ${!isRoot ? '#fdfdfd' : '#002755'};

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }

    .MuiSvgIcon-root {
        font-size: 24px;
    }
`;

export const instagramButton = (isRoot) => css`
    min-width: 40px;
    min-height: 40px;
    transition: all 0.3s ease;
    color: ${!isRoot ? '#fdfdfd' : '#002755'};

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }

    .MuiSvgIcon-root {
        font-size: 24px;
    }
`;

export const loginButton = (isRoot) => css`
    margin-right: 15px;
    transition: all 0.3s ease;
    border-color: ${!isRoot ? '#fdfdfd' : '#002755'} !important;
    color: ${!isRoot ? '#fdfdfd' : '#002755'} !important;
    font-weight: 500;

    &:hover {
        transform: translateY(-2px);
        background-color: ${!isRoot ? '#fdfdfd' : '#002755'} !important;
        color: ${isRoot ? '#fdfdfd' : '#002755'} !important;
    }

    &:active {
        transform: translateY(0);
    }

    .MuiSvgIcon-root {
        font-size: 18px;
    }
`;

export const logoutButton = (isRoot) => css`
    margin-right: 15px;
    transition: all 0.3s ease;
    border-color: ${!isRoot ? '#fdfdfd' : '#002755'} !important;
    color: ${!isRoot ? '#fdfdfd' : '#002755'} !important;
    font-weight: 500;

    &:hover {
        transform: translateY(-2px);
        background-color: ${!isRoot ? '#fdfdfd' : '#002755'} !important;
        color: ${isRoot ? '#fdfdfd' : '#002755'} !important;
    }

    &:active {
        transform: translateY(0);
    }

    .MuiSvgIcon-root {
        font-size: 18px;
    }
`;

export const userButton = (isRoot) => css`
    margin-right: 15px;
    transition: all 0.3s ease;
    color: ${!isRoot ? '#fdfdfd' : '#002755'};
    font-weight: 500;
    min-width: 120px;

    &:hover {
        transform: translateY(-2px);
        background-color: ${!isRoot ? 'rgba(253, 253, 253, 0.1)' : 'rgba(0, 39, 85, 0.1)'};
    }

    &:active {
        transform: translateY(0);
    }

    .MuiSvgIcon-root {
        font-size: 18px;
    }
`;

// export const navigateButtonContainer = (isRoot) => css`
//     display: ${isRoot ? 'none' : 'flex'};
//     flex: 1;
//     justify-content: center;
// `;

// export const geoCoding = (isRoot) => css`
//     display: ${isRoot ? 'flex' : 'none'};
//     text-decoration-line: none;
//     margin-right: 50px;
// `;

// export const geoCodingImg = css`
//     width: 160px;
// `;

export const socialLinksContainer = css`
    display: flex;
    justify-content: end;
    align-items: center;
    flex: 1;
`;
